export const CONTACT_EMAIL = "info@thyra-ai.com";

/**
 * Role and bio are translated: `company` namespace, `team.members.<id>`.
 */
export const TEAM_MEMBERS = [
  {
    id: "farley",
    name: "Farley França",
    linkedinUrl: "https://www.linkedin.com/in/kfbfarley/",
  },
  {
    id: "jose",
    name: "José Ribeiro",
    linkedinUrl: "https://www.linkedin.com/in/jose-ribeir/",
  },
] as const;

export type TeamMember = (typeof TEAM_MEMBERS)[number];
export type TeamMemberId = TeamMember["id"];
